import React, { useEffect, useState } from 'react';
import GlobalTable from '../../../components/CustomTableWithPagination/GlobalTable';
import { dataAnalyticsTableHeader } from '../components/tableHeaderJson';
import { useLocation } from 'react-router-dom';
import GlobalWrapper from '../../../components/Wrapper/GlobalWrapper';
import FromAndToDatePicker from '../../../components/mui/FromAndToDatePicker';
import dayjs from 'dayjs';
import Stack from '@mui/material/Stack';
import { useDispatch } from 'react-redux';
import { getDataAnalyticsDetails } from '../../../redux/features/analyticsSlice';
import { useSelector } from 'react-redux';
import ProgressionDownloadButton from '../../../components/ProgressionDownloadButton';
import { dataAnalyticsCards } from '../utils/cardJson';

export default function DataAnalyticsDetailPage() {
  const location = useLocation();
  const currentPath = location.pathname.slice(25);

  const [fromDate, setFromDate] = useState(dayjs().startOf('month').format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(dayjs().endOf('month').format('YYYY-MM-DD'));
  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    frozenColumns: [],
  });

  // redux states
  const dataAnalyticsData = useSelector((state) => state.analytics.dataAnalytics.data);
  const dataAnalyticsDataLoading = useSelector((state) => state.analytics.dataAnalytics.loading);
  const dataAnalyticsMeta = useSelector((state) => state.analytics.dataAnalytics.meta);

  const dispatch = useDispatch();

  useEffect(() => {
    const params = {
      fromDate,
      toDate,
      pathName: currentPath.slice(1),
      search: tableState.search,
      page: tableState.page,
      limit: tableState.pageSize,
    };

    dispatch(getDataAnalyticsDetails(params));
  }, [dispatch, fromDate, toDate, currentPath, tableState.page, tableState.pageSize, tableState.search]);

  return (
    <GlobalWrapper title={dataAnalyticsCards.filter((item) => item.path === currentPath.slice(1))?.[0]?.title}>
      <Stack gap={2}>
        <Stack direction={{ sm: 'row', xs: 'column' }} justifyContent={'space-between'} gap={1}>
          <FromAndToDatePicker
            fromDate={fromDate}
            toDate={toDate}
            setFromDate={setFromDate}
            setToDate={setToDate}
            fullWidth
          />
          <ProgressionDownloadButton
            downloadFilName="sheet"
            downloadType="text/csv"
            buttonName="Export"
            loadingButtonName="Exporting..."
            sx={{ minWidth: 200 }}
            params={{
              fromDate,
              toDate,
              limit: 'no',
            }}
            url={`data-analytics/${currentPath.slice(1)}`}
          />
        </Stack>
        <GlobalTable
          headers={dataAnalyticsTableHeader?.[currentPath]}
          rows={dataAnalyticsData}
          rowUniqueId="trainer_id"
          meta={dataAnalyticsMeta}
          loading={dataAnalyticsDataLoading}
          tableState={tableState}
          setTableState={setTableState}
        />
      </Stack>
    </GlobalWrapper>
  );
}
